import axios from "axios";
import { getApiEndpointsConfig } from "./config/api-endpoints.config";
import { apiClientProvider } from "./api-client.provider";

const config = getApiEndpointsConfig();
const factory = apiClientProvider.getFactory();

export const apiClientMainV1 = factory.createClient(config.main.v1);
export const apiClientMainV2 = factory.createClient(config.main.v2);
export const apiClientMainV3 = factory.createClient(config.main.v3);

export const apiClientAdminV1 = factory.createClient(config.admin.v1);
export const apiClientAdminV2 = factory.createClient(config.admin.v2);

export const apiClientAuth = factory.createClient(config.auth.v1);
export const apiClientCms = factory.createClient(config.cms);

// no factory: a 401 from the external search engine must not trigger the logout interceptor
export const apiClientMeilisearch = axios.create({
  baseURL: config.meilisearch.baseURL,
  timeout: 30000,
  withCredentials: config.meilisearch.withCredentials,
  headers: {
    "Content-Type": "application/json",
    ...config.meilisearch.headers,
  },
});
